/* eslint-disable @stylistic/padding-line-between-statements */
import {inject, Injectable} from '@angular/core';
import {first, Observable, of} from 'rxjs';
import {map, tap} from 'rxjs/operators';

import {CartQueryService} from '@features/sales/application/store/cart/cart-query.service';
import {OrderCommandService} from '@features/sales/application/store/order/order-command.service';
import {OrderFactory} from '@features/sales/application/factories/order.factory';
import {Order} from '@features/sales/domain/entities/order/order.entity';
import {CartPartitioner} from '@features/sales/domain/services/cart-partitioner.service';
import {SplitMode} from '@features/sales/domain/models/order/order-split.model';
import {SALES_SESSION_PORT, SalesSessionContext} from '@features/sales/domain/ports/sales-session.port';

@Injectable({providedIn: 'root'})
export class CreateCartOrderUseCase {
  private readonly cartQuery = inject(CartQueryService);
  private readonly orders = inject(OrderCommandService);
  private readonly partitioner = inject(CartPartitioner);
  private readonly sessionPort = inject(SALES_SESSION_PORT);
  private readonly orderFactory = inject(OrderFactory);

  execute(mode: SplitMode = SplitMode.SINGLE_ORDER): Observable<Order[]> {
    const cart = this.cartQuery.asEntity();

    if (cart.isEmpty) {
      return of([]);
    }

    return this.sessionPort.getSessionContext().pipe(
      first(),
      map((sessionContext: SalesSessionContext) => {
        const drafts = this.partitioner.partition(cart, {mode});
        return drafts.map((draft) => this.orderFactory.fromDraft(draft, sessionContext));
      }),
      tap((orders) => orders.forEach((order) => this.orders.save(order))),
    );
  }
}
